<template>
  <div class="dropdown-container">
    <button
      class="btn btn-outline-light d-flex px-3 py-2"
      :class="{
        'icon-only': props.iconOnly
      }"
      :id="dropdownId"
      :aria-expanded="menuOpen"
      @click="menuOpen = !menuOpen"
      :aria-label="`${props.label} dropdown`"
    >
      <span class="material-symbols-outlined">{{ props.icon }}</span>
      <span
        v-if="!props.iconOnly"
        class="btn-label"
      >
        {{ props.label }}
      </span>
    </button>
    <ul
      v-if="menuOpen"
      class="dropdown-menu"
      :aria-labelledby="dropdownId"
    >
      <li
        v-for="item in props.menuItems"
        :key="item.label"
      >
        <button
          v-if="item.onClick"
          class="dropdown-item"
          @click="
            (e) => {
              item.onClick(e);
              menuOpen = false;
            }
          "
        >
          {{ item.label }}
        </button>
      </li>
    </ul>
  </div>
  <div
    v-if="menuOpen"
    class="overlay"
    @click="menuOpen = false"
  />
</template>
<script lang="ts" setup>
import { type MenuItem } from '@shared/types/siteHeader';
import { computed, ref } from 'vue';

const props = defineProps<{
  label: string;
  icon: string;
  menuItems: MenuItem[];
  iconOnly?: boolean;
}>();

const menuOpen = ref<boolean>(false);
const dropdownId = computed(() => {
  return `${props.label}-dropdown`;
});
</script>

<style lang="scss" scoped>
.dropdown-container {
  position: relative;
}
.btn-label {
  margin: 0 0.25rem;
}
.dropdown-menu {
  min-width: 250px;
  display: block;
  position: absolute;
  top: 46px; // the button is 38px tall
  right: 0;
  z-index: 100;
}
.dropdown-item {
  font-size: 1rem;
  padding: 1rem 1.5rem;
}
.overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;
}
.icon-only {
  border: none;
  padding: 0 !important;
  .material-symbols-outlined {
    font-size: 2rem;
  }
}
</style>
